import formTagManagerMainEdit from './formTagManagerMainEdit';
import formTagManagerExtendedEdit from './formTagManagerExtendedEdit';
import formTagManagerPosterEdit from './formTagManagerPosterEdit';

export default {
  title: 'Tag Manager',
  attributeName: 'tagmanager',
  getURL: 'tagmanager',
  createURL: 'tagmanager',
  updateURL: 'tagmanager',
  additionaMetadataURL: '',
  removeURL: '',
  canCreate: true,
  idAttribute: 'id',
  sessionParams: [],
  formConfig: [formTagManagerMainEdit,formTagManagerPosterEdit,formTagManagerExtendedEdit],
  noArea: true,
  goBack: true,
};
